import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import CameraHelpModal from './CameraHelpModal';

const t = (key, data) => app.translator.trans('acseven-chdk-cameras.forum.identify.' + key, data);

/**
 * What the photo said. One hit links to the camera, a shared model id links to
 * both, and anything unreadable says which of the four things went wrong.
 *
 * The outcome is a modal rather than text in the row: the row sits above the
 * camera list, and growing it by two lines pushes the whole index down.
 */
export default class CameraIdentifyModal extends Modal {
  className() {
    return 'CameraIdentifyModal Modal--small';
  }

  title() {
    return t('result_title');
  }

  content() {
    const { hits, fw, error } = this.attrs;

    return (
      <div className="Modal-body">
        {error ? (
          <p className="CameraIdentifyModal-message">{t('err_' + error)}</p>
        ) : (
          <p className="CameraIdentifyModal-message">
            {hits.length > 1 ? t('ambiguous') : fw ? t('found_fw', { fw }) : t('found')}
          </p>
        )}

        <div className="CameraIdentifyModal-actions">
          {(hits || []).map((camera) => (
            <Link
              className="Button Button--primary"
              href={app.route('camera', fw ? { id: camera.id, fw } : { id: camera.id })}
              onclick={() => app.modal.close()}
            >
              {camera.name}
            </Link>
          ))}

          {error === 'unknown' && (
            <Button className="Button Button--primary" onclick={() => app.modal.show(CameraHelpModal)}>
              {app.translator.trans('acseven-chdk-cameras.forum.index.not_listed')}
            </Button>
          )}
        </div>
      </div>
    );
  }
}
